import React from 'react';
import { BreadCrumb } from 'primereact/breadcrumb';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { getConfiguredLabel } from '../../common/commonHelper';
import {   HeaderMenu, breadCrumbAdmin, breadCrumbDataSource, breadCrumbNews, home  } from '../../common/labelConstants';

export const BreadCrum = () => {
    let pathNameUrl = window.location.pathname.slice(1).trim();
    let pathName = pathNameUrl;
    const tabName = useSelector(state => state?.banner?.buttonsText?.tabName)
    switch(pathNameUrl){
        case 'newsFeed':
            pathName = getConfiguredLabel(HeaderMenu, breadCrumbNews) || 'News Feed';
            break
        case 'admin':
            pathName = getConfiguredLabel(HeaderMenu, breadCrumbAdmin) || 'User Management';
            break
        case 'dataSource':
            pathName = getConfiguredLabel(HeaderMenu, breadCrumbDataSource) || 'Data Source Management';
            break
    }

    const navigate = useNavigate();
    const handleHome = () => {
        navigate('/Documents')
    }
    const items = [
        {label: <span onClick={handleHome}>{getConfiguredLabel(HeaderMenu,home)}</span>},
        {label: <span>{">>"}</span>},
        {label: <span>{pathName}</span>},
        // {label: tabName}
    ];
 
    return (
        <div>
            <div className="card banner_breadCrumb">
                {tabName && <BreadCrumb  model={items}/>}
            </div>
        </div>
    );
}
       